import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
export var GuestOnlyRoute = function () {
    var user = useAuth().user;
    if (user)
        return _jsx(Navigate, { to: "/" });
    return _jsx(Outlet, {});
};
